
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post/[id]",
      function () {
        return require("private-next-pages/post/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post/[id]"])
      });
    }
  